import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { DesktopInventory } from '@/features/warehouse/DesktopInventario';
import { MobileInventory } from '@/features/warehouse/mobile/MobileInventario';

/**
 * Il conteggio a sessione: si apre, si compila, e solo la chiusura muove i saldi.
 *
 * Sotto i 768px si monta un componente **diverso**: contare è il caso d'uso da telefono per eccellenza
 * — si conta uno scaffale alla volta, e ogni riga va scritta dove si è, non ricordata fino al computer.
 */
export const Route = createFileRoute('/_app/warehouse/inventory')({ component: Inventory });

function Inventory() {
  return useIsMobileShell() ? <MobileInventory /> : <DesktopInventory />;
}
